import SellerShop from './SellerShop';
const MySellerShopPage = () => {
  return <SellerShop useCase="byUser" />;
};
export default MySellerShopPage;
